import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import { Currency } from "_shared/money/currencies/currency";
import MoneySchema, { MoneyJSON, MoneyParams } from "_shared/money/money-schema";

export default class Money {
  public static get EXAMPLE(): Money {
    return new Money(0, Currency.ALL);
  }

  public static create(values: MoneyParams): Money {
    const parsed = MoneySchema.validate(values);
    return new Money(parsed.amount, parsed.currency);
  }

  public static fromJSON(
    json: MoneyJSON | null | undefined
  ): Money | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const parsed = MoneySchema.validate(json);
    return new Money(parsed.amount, parsed.currency);
  }
  
  public constructor(
    public readonly amount: number,
    public readonly currency: Currency
  ) {}
  
  public toJSON(): MoneyJSON {
    return MoneySchema.validate(this);
  }

  public valueOf(): MoneyJSON {
    return this.toJSON();
  }

  public clone(): Money {
    return new Money(this.amount, this.currency);
  }

  public isEqualTo(other: Money | null | undefined): boolean {
    return this.amount === other?.amount && this.currency === other?.currency;
  }

  public toString(): string {
    return `${this.amount} ${this.currency}`;
  }
}

export class InvalidMoneyError extends Error {
  constructor(context: { values: Partial<Money>; message: string }) {
    super(
      `Invalid money: ${JSON.stringify(context.values)}\n${context.message}`
    );
  }
}
